import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="add" repeat="5" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`Add the Media extension and its dependencies to your project using the app's Gradle file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`implementation 'com.adobe.marketing.mobile:sdk-core:1.+'
implementation 'com.adobe.marketing.mobile:analytics:1.+'
implementation 'com.adobe.marketing.mobile:media:2.+'
`}</code></pre>
    <p>{`You can also manually include the libraries. Get `}<inlineCode parentName="p">{`.aar`}</inlineCode>{` libraries from `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/tree/master/android"
      }}>{`Github`}</a>{`.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Import the Media extension in your application's main activity.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.*;
`}</code></pre>
    <Variant platform="ios" task="add" repeat="8" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`To add the Media library and its dependencies to your project, add the following pods to your `}<inlineCode parentName="li">{`Podfile`}</inlineCode>{`:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-pod"
      }}>{`pod 'ACPCore', '~> 2.0'
pod 'ACPAnalytics', '~> 2.0'
pod 'ACPMedia', '~> 2.0'
`}</code></pre>
    <p>{`You can also manually include the libraries. Get `}<inlineCode parentName="p">{`.a`}</inlineCode>{` libraries from `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/tree/master/iOS"
      }}>{`Github`}</a>{`.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In Xcode project, import Media extension:`}</li>
    </ol>
    <p><strong parentName="p">{`Swift`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import ACPMedia
`}</code></pre>
    <p><strong parentName="p">{`Objective-C`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`#import "ACPMedia.h"
`}</code></pre>
    <Variant platform="react-native" task="add" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <ol>
      <li parentName="ol">{`Install Media.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`   npm install @adobe/react-native-acpmedia
`}</code></pre>
    <p>{`1.1 Link`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`React Native 0.60+`}</strong></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://github.com/react-native-community/cli/blob/master/docs/autolinking.md"
      }}>{`CLI autolink feature`}</a>{` links the module while building the app.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`React Native `}{`<`}{`= 0.59`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`   react-native link @adobe/react-native-acpmedia
`}</code></pre>
    <p><em parentName="p">{`Note`}</em>{` For `}<inlineCode parentName="p">{`iOS`}</inlineCode>{` using `}<inlineCode parentName="p">{`cocoapods`}</inlineCode>{`, run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`   cd ios/ && pod install
`}</code></pre>
    <ol>
      <li parentName="ol">{`Import the extension.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {ACPMedia} from '@adobe/react-native-acpmedia';
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPMedia.extensionVersion().then(version => console.log("AdobeExperienceSDK: ACPMedia version: " + version));
`}</code></pre>
    <Variant platform="android" task="register" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p>{`To register media with Mobile Core, call the `}<inlineCode parentName="p">{`setApplication()`}</inlineCode>{` method in `}<inlineCode parentName="p">{`onCreate()`}</inlineCode>{` and call set up methods, as shown in this sample:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.*;

public class MobileApp extends Application {

  @Override
  public void onCreate() {
      super.onCreate();
      MobileCore.setApplication(this);

      try {
          Media.registerExtension();
          Analytics.registerExtension();
          Identity.registerExtension();
          MobileCore.start(new AdobeCallback () {
              @Override
              public void call(Object o) {
                  MobileCore.configureWithAppID("your-launch-app-id");
              }
          });
      } catch (InvalidInitException e) {

      }
  }
}
`}</code></pre>
    <Variant platform="ios" task="register" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p>{`In your app's `}<inlineCode parentName="p">{`_:didFinishLaunchingWithOptions`}</inlineCode>{` function, register the Audience Manager extension with the Mobile Core:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import ACPCore
import ACPAnalytics
import ACPIdentity
import ACPMedia

func application(_ application: UIApplication,
                 didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
    ACPCore.setLogLevel(.debug)
    ACPCore.configure(withAppId: "your-launch-app-id")

    ACPAnalytics.registerExtension()
    ACPIdentity.registerExtension()
    ACPMedia.registerExtension()

    ACPCore.start {

    }

    return true;
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p>{`In your app's `}<inlineCode parentName="p">{`application:didFinishLaunchingWithOptions`}</inlineCode>{`, register Media with Mobile Core:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`#import "ACPCore.h"
#import "ACPAnalytics.h"
#import "ACPIdentity.h"
#import "ACPMedia.h"

- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    [ACPCore setLogLevel:ACPMobileLogLevelDebug];
    [ACPCore configureWithAppId:@"your-launch-app-id"];

    [ACPAnalytics registerExtension];
    [ACPIdentity registerExtension];
    [ACPMedia registerExtension];

    [ACPCore start:^{

    }];

    return YES;
  }
`}</code></pre>
    <Variant platform="react-native" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <p>{`When using React Native, registering Media with Mobile Core should be done in native code which is shown under the Android and iOS tabs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      